import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Header from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div>
        <Header />
        <div className="max-w-md mx-auto px-4 py-16 text-center">
          <h1 className="font-display text-2xl font-medium mb-2">Invalid reset link</h1>
          <p className="text-sm text-neutral-500 mb-6">This password reset link is missing a token.</p>
          <Link to="/forgot-password"><Button className="rounded-full bg-blue-600 hover:bg-blue-700" data-testid="reset-back">Request a new link</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <h1 className="font-display text-3xl tracking-tight font-medium mb-2">Choose a new password</h1>
        <p className="text-neutral-600 mb-8 text-sm">Make it at least 6 characters.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>New password</Label>
            <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 rounded-xl" data-testid="reset-password" />
          </div>
          <div>
            <Label>Confirm password</Label>
            <Input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-xl" data-testid="reset-confirm" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 h-11" data-testid="reset-submit">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
